import _ from 'lodash';

import { faIcons, faSVG } from 'assets/js/mixins/icons';
import { READ_ONLY_MODE, STANDALONE } from 'assets/js/api/environment';

export const mixinProps = {
  dispenseGlobalProp: {
    type: Object,
    default: () => {},
    required: false,
  },

  // Return the object mapping font-awesome icons.
  faIcons: {
    type: Object,
    default: () => faIcons,
    required: false,
  },

  // Attach the faSVG function to this object
  faSVG: {
    type: Function,
    default: faSVG,
    required: false,
  },

  lodash: {
    default: () => _,
    required: false,
  },

  QReserveReadOnlyMode: {
    type: Boolean,
    default: READ_ONLY_MODE,
    required: false,
  },

  QReserveStandaloneInstall: {
    type: Boolean,
    default: STANDALONE,
    required: false,
  },
};
